module.exports = __webpack_public_path__ + "static/img/stand.0840e3ce.png";